import classNames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from 'src/components/Button/Button';
import Icon from 'src/components/Icon/Icon';

import BreadCrumb from 'src/components/Retail/BreadCrumb/BreadCrumb';
import RetailPage from 'src/containers/Page/RetailPage';
import './RegisterBet.scss';

function RegisterBet() {
  const { t } = useTranslation();
  const [betId, setBetId] = useState('');

  const dispatch = useDispatch();

  const handleBookBet = (e) => {
    e.preventDefault();
    dispatch.betslip.bookBet(betId);
  };

  const handlePlaceBet = (e) => {
    e.preventDefault();
    dispatch.betslip.placeBookedBet(betId);
  };

  return (
    <RetailPage includeBetslip>
      <BreadCrumb
        breadcrumbs={
          [
            { name: t('navBar.registerBet'), link: '/register-bet' }
          ]
        }
      />
      <div className="book-bet">
        <div className="book-bet__title">
          { t('retail.registerBetTitle') }
        </div>
        <input
          autoComplete="new-password"
          value={ betId }
          onChange={ (e) => setBetId(e.target.value) }
          type="text"
          className="book-bet__input"
        />
        <button
          type="submit"
          onClick={ handleBookBet }
          className={
            classNames({
              'code-search__button' : true,
              'code-search__button--disabled': betId === ''
            })
          }
        >
          <Icon
            icon="return"
            className={
              classNames({
                'code-search__check': true,
                'code-search__check--disabled': betId === ''
              })
            }
          />
        </button>
        <Button className="book-bet__place-bet btn btn--cta" text={ t('betslip.placeBetBtn') } onClick={ handlePlaceBet } />
      </div>
    </RetailPage>
  );
}

export default RegisterBet;
